class FooterMenuBlock extends HTMLElement {
  constructor() {
    super()
    const blockNum = this.dataset.blockNum
    if(blockNum != 1){
      this.links = document.querySelector(`.menuLinks-${blockNum}`)
      this.toggleICon = document.querySelector(`#toggleMenuIcon-${blockNum}`)
      this.addEventListener("click", this.toggleMenu.bind(this))
    }
    this.float()
  }

  toggleMenu(){
    this.classList.toggle("active")
    this.toggleICon.classList.toggle("active")
    this.links.classList.toggle("active")
  }

  float() {
    const group = document.querySelectorAll(".footer_form_field")
    group.forEach(function (ele) {
      const input = ele.querySelector("input")

      input.addEventListener("focus", function () {
        ele.classList.add("label-up")
        ele.classList.add("focus")
      })

      input.addEventListener("blur", function () {
        ele.classList.remove("focus")
        if (!input.value) {
          ele.classList.remove("label-up")
        }
      })
    })
  }
}
customElements.define("footer-menu-block", FooterMenuBlock)